/**
 * 系统栏目ID
 */
export default {
    // 首页
    home: {
        self: '2',
        banner: '7',
        // 首页的景区动态和游客服务活动咨询-景区动态是同一个
        jingQuDongTai: '78',
        // 首页的通知公告跟游客服务活动咨询-景区公告是同一个
        jingQuGongGao: '77',
        bianJieFuWu: '9',
        yuPiaoShuJu: '10',
        jingDianXianLu: '11',
        daMeiEMei: '12',
        jingCaiTiYan: '13',
        gongLueTuiJian: '14'
    },
    // 圣地峨眉
    shrine: {
        self: '3',
        jingQuJianJie: '15',
        biaoZhiJingDian: '16',
        zuiJiaTiYan: '17',
        shuangYiChan: '18',
        jingQuXinShang: '21'
    },
    // 玩转峨眉
    play: {
        self: '4',
        chiDeBaShi: '22',
        zhudeShuShi: '23',
        wanDeAnYi: '24',
        gouDeKaiXin: '25',
        jieQingHuoDong: '26'
    },
    // 旅游攻略
    intro: {
        self: '5',
        jingDianXianLu: '27',
        zhuTiChanPin: '28',
        daRenGongLue: '29',
        DaEMei: '30'
    },
    // 游客服务
    visitor: {
        self: '6',
        youKeXuZhi: '31',
        jingQuReXian: '94',
        huoDongZiXun: '32',
        piaoJiaXinXi: '33',
        jiaoTongZhiYin: '34',
        jiaoTongZhiYinMobile: '1749268887995797505',
        weiLaiQiRiYuPiao: '35'
    },
    aboutus: {
        guanYuWoMen: '37',
        liShiRongYu: '38'
    },
    // 精彩视频
    video: '666',
    // 直播
    live: '777',
    // 精美图库
    picture: '888',
    // 常见问题
    question: '999',
	english: {
		banner: '1751808080236105730',
		about: '1745247750735351810',
		notice: '1745247889847832577',
		culture: {
			id: '1745244258020970498',
			childs: {
				buddhist: '1745247030871150594',
				martial: '1745247243513974785',
				tea: '1745247354512035842',
				food: '1745247465900167169'
			}
		},
		play: '1745246819314651137',
		hotel: '1745246625424560129',
		gift: '1745248002116767745',
		events: '1745244322302873602',
		video: '1752208178623401985',
		picture: '1752208505368072194',
	},
}



// WEBPACK FOOTER //
// ./src/enum/SystemColumnId.js